import React from 'react';
import { Box } from '@mui/material';
import ReportDownloadButton from '../common/ReportDownloadButton';
import ReportTitle from '../common/ReportTitle';

const ClassroomCharacterReportHeader: React.FC = () => {
  return (
    <Box display="flex" justifyContent="space-between" alignItems="center">
      <ReportTitle gutterBottom />
      <ReportDownloadButton className="noPrint" />
    </Box>
  );
};

export default ClassroomCharacterReportHeader;
